import { Avatar, type Theme } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

interface UserAvatarProps {
  photoUrl?: string;
  initials: string;
  isAdmin?: boolean;
  size?: number;
}

function getResponsiveAvatarSx(size: number) {
  const mobileSize = Math.max(size - 4, 0);

  return (theme: Theme) => ({
    width: mobileSize,
    height: mobileSize,
    flexShrink: 0,
    [theme.breakpoints.up("sm")]: {
      width: size,
      height: size,
    },
  });
}

function getResponsiveInitialsSx(size: number) {
  return (theme: Theme) => ({
    fontSize: Math.round(size * 0.28125),
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.up("sm")]: {
      fontSize: Math.round(size * 0.34375),
      fontWeight: theme.typography.fontWeightBold,
    },
  });
}

function getResponsiveAdminIconSx(size: number) {
  return (theme: Theme) => ({
    fontSize: Math.round(size * 0.4375),
    color: theme.palette.common.white,
    [theme.breakpoints.up("sm")]: {
      fontSize: Math.round(size * 0.5625),
    },
  });
}

export default function UserAvatar({
  photoUrl,
  initials,
  isAdmin,
  size = 32,
}: Readonly<UserAvatarProps>) {
  if (isAdmin) {
    return (
      <Avatar sx={[getResponsiveAvatarSx(size), (theme) => ({ bgcolor: theme.palette.grey[600] })]}>
        <AdminPanelSettingsIcon sx={getResponsiveAdminIconSx(size)} />
      </Avatar>
    );
  }

  return (
    <Avatar
      src={photoUrl}
      sx={[
        getResponsiveAvatarSx(size),
        getResponsiveInitialsSx(size),
        (theme) => ({
          bgcolor: theme.palette.primary.main,
          color: theme.palette.common.white,
        }),
      ]}
    >
      {initials}
    </Avatar>
  );
}
